import Statistic from 'amkit3-modules/v/statistic'

import HuyaCollector from './collector'
import AdStatistic from './ad'

class HuyaStatistic extends Statistic {
  constructor(player) {
    super(player)

    new AdStatistic(this.collector)
  }
  getCollector(player) {
    return new HuyaCollector(player)
  }
}

export default HuyaStatistic
